export default {"src":"/_next/static/media/KeepaNewLogoLeft.3193fbf9.svg","height":32,"width":132};